// extracted by mini-css-extract-plugin
export default {"container":"clients_container__G-Q9T","title":"clients_title__orVK5","card":"clients_card__jBdv1","clients":"clients_clients__gvWfN","client":"clients_client__pjDYg"};